import { ChipListMultiselectItem, ChipListMultiselectOptions } from '@mydocma/component-library/src/lib/chips';
import {FieldConfig} from '../../dynamic-field/field.config';

export interface ChipsMultiSelectFieldConfig extends FieldConfig<ChipListMultiselectItem[]> {
    getSource?: () => Promise<ChipListMultiselectItem[]>;
    source?: ChipListMultiselectItem[];
    options?: ChipListMultiselectOptions;
}
